import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './LocationSelector.module.css';
import CrossHairsIcon from 'assets/images/crosshairs.svg';
import Autocomplete from 'containers/Maps/Autocomplete/Autocomplete';
import AutocompleteMap from 'containers/Maps/AutocompleteMap/AutocompleteMap';
import ImportantPlaceForm from 'containers/Maps/ImportantPlaceForm/ImportantPlaceForm';
import { importantPlaceIcons, truncateText } from 'shared/utility';
import * as actions from 'store/actions';

class LocationSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showImportantPlaceForm: false,
      importantPlaceFormType: null,
      showImportantPlacesList: false,
      showRecentPlacesList: false,
      activeImportantPlace: null,
      hoveredImportantPlaceId: null,
    };
  }

  componentDidMount() {
    this.props.onFetchImportantPlaces();
    this.props.onFetchRecentPlaces();
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.importantPlaceSubmitted && this.props.importantPlaceSubmitted) {
      this.props.onFetchImportantPlaces();
    }
    if (this.props.location !== prevProps.location && !this.props.location.locationFav) {
      this.setState({ activeImportantPlace: null });
    }
  }

  toggleComponent = (componentName) => {
    this.setState({ [componentName]: !this.state[componentName] });
  };

  toggleImportantPlaceForm = (formType) => {
    this.setState({ showImportantPlaceForm: !this.state.showImportantPlaceForm, importantPlaceFormType: formType });
  };

  toggleFooterElement = (componentName) => {
    if (componentName === 'recentPlaces') {
      this.setState({ showRecentPlacesList: !this.state.showRecentPlacesList, showImportantPlacesList: false });
    } else {
      this.setState({ showRecentPlacesList: false, showImportantPlacesList: !this.state.showImportantPlacesList });
    }
  };

  handleEditImportantPlaceFormLaunch = (importantPlace) => {
    this.setState({ activeImportantPlace: importantPlace, showImportantPlaceForm: true, importantPlaceFormType: 'edit' });
  };

  handleImportantPlaceSelect = (importantPlace) => {
    this.props.handleLocationUpdate(
      importantPlace.Location,
      importantPlace.Location2,
      { lat: parseFloat(importantPlace.Lat), lng: parseFloat(importantPlace.Lng) },
      { lat: parseFloat(importantPlace.MapLat), lng: parseFloat(importantPlace.MapLng) },
      parseInt(importantPlace.Zoom, 10),
      importantPlace.MapType,
      parseFloat(importantPlace.Pitch),
      parseFloat(importantPlace.Heading),
      importantPlace.LocIcon,
      true,
      importantPlace.Id,
    );
    this.toggleFooterElement('importantPlaces');
  };

  handleRecentPlaceSelect = (recentPlace) => {
    this.props.handleLocationUpdate(
      recentPlace.Location,
      recentPlace.Location2,
      { lat: parseFloat(recentPlace.Lat), lng: parseFloat(recentPlace.Lng) },
      { lat: parseFloat(recentPlace.MapLat), lng: parseFloat(recentPlace.MapLng) },
      parseInt(recentPlace.Zoom, 10),
      recentPlace.MapType,
      parseFloat(recentPlace.Pitch),
      parseFloat(recentPlace.Heading),
      null,
      false,
      null,
    );
    this.toggleFooterElement('recentPlaces');
  };

  getPosition = () => {
    // Simple wrapper
    return new Promise((res, rej) => {
      navigator.geolocation.getCurrentPosition(res, rej);
    });
  };

  handleCurrentLocationSelect = () => {
    if (navigator.geolocation) {
      this.getPosition()
        .then((position) => {
          return { lat: position.coords.latitude, lng: position.coords.longitude };
        })
        .then((latLng) => {
          const zoom = this.props.zoom < 17 ? 17 : this.props.zoom;
          const mapTypeId = this.props.mapTypeId === 'streetview' ? 'roadmap' : this.props.mapTypeId;
          this.props.handleLocationUpdate(null, null, null, latLng, zoom, mapTypeId);
        })
        .catch((error) => {
          console.log('error', error);
          switch (error.code) {
            case error.TIMEOUT:
              alert('Browser geolocation error !\n\nTimeout.');
              break;
            case error.PERMISSION_DENIED:
              if (error.message.indexOf('Only secure origins are allowed') === 0) {
                alert('Cannot access location for url without ssl certificate');
              }
              break;
            case error.POSITION_UNAVAILABLE:
              alert('Browser geolocation error !\n\nPosition unavailable.');
              break;
            default:
              break;
          }
        });
    }
  };

  render = () => {
    const containerClasses = [classes.Container];
    let importantPlaceForm = null;
    const footerClasses = [classes.FooterExpansion];
    let importantPlaceList = null;
    let recentPlacesList = null;
    if (this.props.type) containerClasses.push(classes[this.props.type]);
    if (this.state.showRecentPlacesList || this.state.showImportantPlacesList) footerClasses.push(classes.Expanded);
    if (this.state.showRecentPlacesList && !this.state.showImportantPlacesList) footerClasses.push(classes.Dark);
    if (this.props.shortWindow) containerClasses.push(classes.ShortWindow);
    if (this.state.showImportantPlaceForm) {
      importantPlaceForm = (
        <ImportantPlaceForm
          location={this.state.activeImportantPlace !== null ? this.state.activeImportantPlace : this.props.location}
          formType={this.state.activeImportantPlace ? 'edit' : 'create'}
          error={this.props.error}
          handleLocationUpdate={this.props.handleLocationUpdate}
          close={() => this.toggleImportantPlaceForm(null)}
        />
      );
    }
    if (this.state.showImportantPlacesList) {
      importantPlaceList = (
        <div className={classes.ImportantPlacesList}>
          <h3 className={classes.Title}>My Important Places</h3>
          <div className={classes.List}>
            {this.props.importantPlaces.map((importantPlace) => {
              const locationIcon =
                importantPlace.LocIcon && importantPlaceIcons.filter((icon) => icon.name === importantPlace.LocIcon).length > 0
                  ? importantPlaceIcons.filter((icon) => icon.name === importantPlace.LocIcon)[0]
                  : null;
              const listItemClasses = [classes.ListItem];
              if (this.state.hoveredImportantPlaceId === importantPlace.Id) listItemClasses.push(classes.Active);
              return (
                <div
                  className={listItemClasses.join(' ')}
                  key={importantPlace.Id}
                  onMouseEnter={() => this.setState({ hoveredImportantPlaceId: importantPlace.Id })}
                  onMouseLeave={() => this.setState({ hoveredImportantPlaceId: null })}
                >
                  <div className={classes.ImportantPlaceIconContainer}>
                    <locationIcon.image alt={locationIcon.name} fillColor="#01a2db" type="ImportantPlaceListItem" />
                  </div>
                  <div className={classes.Location} onClick={() => this.handleImportantPlaceSelect(importantPlace)}>
                    <h3>{truncateText(importantPlace.Location, 35)}</h3>
                    <p>{truncateText(importantPlace.Location2, 45)}</p>
                  </div>
                  <FontAwesomeIcon
                    icon="pencil-alt"
                    className={classes.EditIcon}
                    onClick={() => this.handleEditImportantPlaceFormLaunch(importantPlace)}
                  />
                </div>
              );
            })}
          </div>
        </div>
      );
    }

    if (this.state.showRecentPlacesList) {
      recentPlacesList = (
        <div className={classes.RecentPlacesList}>
          <h3 className={classes.Title}>Recent Places</h3>
          <div className={classes.List}>
            {this.props.recentPlaces.map((recentPlace, i) => (
              <div className={classes.ListItem} key={`recent-place-${i}`}>
                <p onClick={() => this.handleRecentPlaceSelect(recentPlace)}>
                  {recentPlace.Location2
                    ? recentPlace.Location && recentPlace.Location.length > 0
                      ? `${recentPlace.Location}, ${recentPlace.Location2}`
                      : recentPlace.Location2
                    : recentPlace.Location}
                </p>
              </div>
            ))}
          </div>
        </div>
      );
    }
    return (
      <div className={containerClasses.join(' ')}>
        {importantPlaceForm}
        <Autocomplete
          geoLocation={this.props.geoLocation}
          address={this.props.address}
          isImportantPlace={this.props.location.locationFav === true}
          handleLocationUpdate={this.props.handleLocationUpdate}
          handleLocationDeletion={this.props.handleLocationDeletion}
          toggleImportantPlaceForm={() => this.toggleImportantPlaceForm('create')}
        />
        <AutocompleteMap
          width="360px"
          markerColor={this.props.markerColor}
          shortWindow={this.props.shortWindow}
          locationSelected={this.props.locationSelected}
          includeMarker={this.props.includeMarker}
          locationIcon={this.props.location.locationIcon}
          geoLocation={this.props.geoLocation}
          center={this.props.center}
          zoom={this.props.zoom}
          address={this.props.address}
          mapTypeId={this.props.mapTypeId}
          pitch={this.props.pitch}
          heading={this.props.heading}
          handleLocationUpdate={this.props.handleLocationUpdate}
        />

        <div className={footerClasses.join(' ')}>
          <div className={classes.Contents}>
            {importantPlaceList}
            {recentPlacesList}
          </div>
        </div>
        <div className={classes.Footer}>
          <p className={classes.ImportantPlacesLink} onClick={() => this.toggleFooterElement('importantPlaces')}>
            My Important Places
          </p>
          <p className={classes.RecentPlacesLink} onClick={() => this.toggleFooterElement('recentPlaces')}>
            Recent Places
          </p>
          <img onClick={this.handleCurrentLocationSelect} src={CrossHairsIcon} className={classes.CurrentLocationIcon} alt="map marker" />
        </div>
      </div>
    );
  };
}

const mapStateToProps = (state) => {
  return {
    importantPlaces: state.fav.importantPlaces,
    importantPlaceSubmitted: state.fav.submitted,
    recentPlaces: state.recent.recentPlaces,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onFetchImportantPlaces: () => dispatch(actions.fetchImportantPlaces()),
    onFetchRecentPlaces: () => dispatch(actions.fetchRecentPlaces()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LocationSelector);
